import { type AppearancePreferences } from './appearance.ts';
import { createDesktopTheme } from './desktopTheme.ts';

// Unified appearance: Mobile now adopts the clean, compact desktop aesthetic
export function createYomiriAppearance(preferences: AppearancePreferences, _mobile: boolean) {
  return createDesktopTheme(preferences);
}
